function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) 2018-2020 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagUZ(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURf39/R65Ovf3+AKiwASoxQCduSC/PPLy8iHEPiLHP4DO3MLl7CAzPEAAAAFsSURBVDjLvY0xa8MwEIUP/YJ48SxEwZAsoZIWdwlVu3QKCFFol3gRGYsXg7NkMh27dis00CFbf2FPkhWXhCoJhD5OT+/uPstwl9YMLgNsJxv0h7GrA0BxcQMbLoS4JeqaCMEVV2iKo5SYAU4+Jr4vW16OudtzXyjBp4Dc9xXvpfh+8kC9Aw4VX9CSa0zB/S2DzcFI+bXSumxl2aJrLaUxzt2Rcg7amOfm0zw2fUncGifpfQoG2+3q/qk1oZy0kdoj0uAv0roE8P+iBxPGGGWE9E6dExImThRwxIgv5tzfNGSg+AX0Y/yG+kD8Q/EF6oGUTgDqqKKo66Zwd0hFwTBTwIDjpigC4rsecvkFGlw2UTWeocNcI7DbDNQvJgJ/6gTgPa2348BrWuuzgeVeWsOy66xdosdj7dB33QKwDcMunm7orV2DTWtxHMirKsty9Kpynu/6PHc+Ar+KbVxYm1XWofkIspSq7AiQXQL4AcnYirvhzpqxAAAAAElFTkSuQmCC",
    alt: "UZ"
  }, props));
}